import { parseLocation } from "pages/CalendarPage/CalendarHelper";

export const fetchEvents = async (token, options) => {
	const { startTime, endTime, maxResults, includeAllDay, sorted } = options;

	const url = new URL(`${process.env.REACT_APP_PORT}/calendar/getEvents`);
	if (startTime) url.searchParams.set("startTime", startTime);
	if (endTime) url.searchParams.set("endTime", endTime);
	if (maxResults) url.searchParams.set("maxResults", maxResults);
	if (typeof includeAllDay === "boolean")
		url.searchParams.set("includeAllDay", includeAllDay);
	if (typeof sorted === "boolean") url.searchParams.set("sorted", sorted);

	const response = await fetch(url, {
		method: "GET",
		headers: { Authorization: `Bearer ${token}` },
	});

	const data = await response.json();

	if (response.status === 200) {
		const result = data.data;
		result.events = result?.events?.map((event) => ({
			...event,
			start: new Date(event.start),
			end: new Date(event.end),
			source: parseLocation(event.link),
		}));

		return result;
	} else {
		return false;
	}
};

// event params should be an object with the following properties:
// {
//     eventId: string,
//     workspaceId: string,
// }
export const deleteEvent = async (token, eventParams) => {
	const url = new URL(`${process.env.REACT_APP_PORT}/calendar/deleteEvent`);

	const response = await fetch(url, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify(eventParams),
	});

	const data = await response.json();

	if (response.status === 200) return true;
	else {
		console.log("Unable to delete event");
		console.log(data);
		return false;
	}
};

export const createOrUpdateEvent = async (token, values) => {
	const url = new URL(
		`${process.env.REACT_APP_PORT}/calendar/createOrUpdateEvent`
	);

	const response = await fetch(url, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify(values),
	});

	const data = await response.json();

	if (response.status === 200 || response.status === 201) {
		const { updatedEvent } = data;

		updatedEvent.start = new Date(updatedEvent.start);
		updatedEvent.end = new Date(updatedEvent.end);
		updatedEvent.source = parseLocation(updatedEvent.link);

		return updatedEvent;
	} else {
		console.log("Unable to create event");
		console.log(data);
		return false;
	}
};

export const removeConferenceData = async (token, eventParams) => {
	const url = new URL(
		`${process.env.REACT_APP_PORT}/calendar/removeConferenceData`
	);

	const response = await fetch(url, {
		method: "PATCH",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify(eventParams),
	});

	const data = await response.json();

	if (response.status === 200) return true;
	else {
		console.log("Unable to remove conference data");
		console.log(data);
		return false;
	}
};
